import { request } from "@/api/client";
import type { AudienceSelection } from "@/types/marketing";

export type SchedulePostPayload = {
  taskId?: string;
  assetId?: string;
  caption: string;
  platforms: string[];
  scheduledFor: string;
  options?: {
    instagramType?: "feed" | "reel";
    tiktokCover?: string;
    audience?: AudienceSelection;
  };
};

export async function schedulePost(payload: SchedulePostPayload) {
  return request("/marketing/scheduler/schedule", {
    method: "POST",
    body: payload,
  });
}
